import React, { PureComponent } from "react";
import classNames from "../../utils/classnames";

export class TabBar extends PureComponent {
  render() {
    const { className, children } = this.props;
    const cls = classNames({
      "weui-tabbar": true,
      [className]: className
    });
    return (
      <div className={ cls } role="tablist" aria-label="选项卡标题">
        { children }
      </div>
    );
  }
}
